import React, { useState, useEffect } from "react";
import { Container, Label, Input, FormGroup, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form, Field, FieldArray, } from 'formik';
import { Loading } from '../../share/loading'
import { FaSistrix } from "react-icons/fa";
import { BsPlusLg } from "react-icons/bs";
import CreateTableComponent from "../../share/CreateTableComponent";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit3 } from "react-icons/fi";
import * as Yup from 'yup'
import { useNavigate } from "react-router-dom";
import '../../share/form.css';
import { useSearchParams } from "react-router-dom";
import Swal from 'sweetalert2'
import 'react-datepicker/dist/react-datepicker.css'

export function DetailInnovationPersonTrainComponent() {
    let rootColorPrimary = "#0A66C2";
    let rootColorErrors = "#d33";
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const supportInnovationId = searchParams.get("req")
    // let status = searchParams.get("status")
    const [dataPerson, setDataPerson] = useState([]);
    const [data, setData] = useState({});
    // console.log("dataperson", dataPerson)

    const [openModalForm, setOpenModalForm] = useState(false);
    const modalToggle = () => setOpenModalForm(!openModalForm);

    const [openModalFileForm, setOpenModalFileForm] = useState(false);
    const modalFileToggle = () => setOpenModalFileForm(!openModalFileForm);
    const [courseInnovationId, setCourseInnovationId] = useState([]);
    //   const [classInnovationId, setClassInnovationId] = useState([]);

    const [isEditing, setIsEditing] = useState(false);
    const [selectItem, setSelectItem] = useState(null);
    const user = JSON.parse(localStorage.getItem("userData"))


    const checkPreviousPage = () => {
        return navigate(`/supporting/Form/DetailInnovationPersonTrainAndExpected?req=${supportInnovationId}&&status=${searchParams.get("status")}`)
    }
    // ดึงข้อมูลมาใหม่ user เลือก
    useEffect(() => {
        async function getCourseInnovationId() {
            setLoading(true)
            let postData = new FormData();
            postData.append("supportInnovationid", Number(searchParams.get("req")))
            try {
                let res = await fetch(`api/SupportInnovation/listInnovationRegister`, {
                    method: "POST",
                    body: postData
                })
                const resJson = await res.json();
                setCourseInnovationId(resJson.dataenum);
            } catch (e) {
                console.log("err=>", e)

            } finally {
                setLoading(false)
            }

        }
        getCourseInnovationId()
    }, [])

    useEffect(() => {
        getPersonTrainInnovation()
        getInnovationInitialValue()
    }, [])



    async function getPersonTrainInnovation() {
        setLoading(true);
        let postData = new FormData();
        postData.append("supportInnovationId", Number(supportInnovationId))
        try {
            let res = await fetch("api/Support/getPersonTrainInnovation/", {
                method: "POST",
                body: postData,
            })
            let resJson = await res.json();
            console.log("resJaon", resJson.dataenum)
            if (!resJson.dataenum) {
                return;
            } else {

                Object.keys(resJson.dataenum).forEach((key) => {
                    if (resJson.dataenum[key] === null) {
                        resJson.dataenum[key] = "";
                    }
                });
                setData(resJson.dataenum)
                // console.log(resJson.dataenum,"data")
            }

        } catch (e) {
            console.log("err", e)
        } finally {
            setLoading(false);
        }
    }

    async function getInnovationInitialValue() {
        setLoading(true);
        let postData = new FormData();
        postData.append("supportInnovationId", Number(supportInnovationId))
        try {
            let res = await fetch("api/SupportInnovation/getPersonTrainInnovation/", {
                method: "POST",
                body: postData,
            })
            let resJson = await res.json();
            setDataPerson(resJson.dataenum);
        } catch (e) {
            console.log("err", e)
        } finally {
            setLoading(false);
        }
    }


    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    function onClickUrl(url) {
        return () => openInNewTab(url)
    }



    const initialValues = {
        registerId: user.registerId,
        supportInnovationId: supportInnovationId,
        // dataPersonTrainAr: "",
        // fAuthrisePath: "",
        // fAuthrisePathView: "",
        fOtherPath: "",
        fOtherPathView: "",
        // fIdCardPath: "",
        // fIdCardPathView: "",
        fCourseTrainPath: "",
        fCourseTrainPathView: ""
    };

    const onSubmit = async (values) => {
        Swal.fire({
            icon: "info",
            title: "ยืนยันการส่งคำขอหรือไม่?",
            text: "",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            cancelButtonColor: "#ff0000",
        }).then(async (result) => {
            if (result.isConfirmed) {
                let postData = new FormData();
                Object.entries(values).forEach(([key, value]) => {
                    postData.append(key, value);
                });

                try {
                    let res = await fetch("/api/Support/saveSupportPersonTrainInnovation", {
                        method: "POST",
                        body: postData
                    });

                    let resJson = await res.json();

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                return navigate(`/supporting`)
                            }
                        })
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        })
    }

    const validationFormSchema = Yup.object().shape({

        // fAuthrisePath: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //     // If the value is falsy or not a file, skip the validation
        //     if (!value || !value.type) {
        //         return true;
        //     }
        //     // Otherwise, check if the file type is allowed
        //     return ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        // })
        //     .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', value => {
        //         // If the value is falsy or not a file, skip the validation
        //         if (!value || !value.size) {
        //             return true;
        //         }
        //         // Otherwise, check if the file size is less than or equal to 1 MB
        //         const maxSize = 5000000; // 1 MB
        //         return value.size <= maxSize;
        //     }),

        fOtherPath: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
            // If the value is falsy or not a file, skip the validation
            if (!value || !value.type) {
                return true;
            }
            // Otherwise, check if the file type is allowed
            return ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        })
            .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', value => {
                // If the value is falsy or not a file, skip the validation
                if (!value || !value.size) {
                    return true;
                }
                // Otherwise, check if the file size is less than or equal to 1 MB
                const maxSize = 5000000; // 1 MB
                return value.size <= maxSize;
            }),

        // fIdCardPath: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
        //     // If the value is falsy or not a file, skip the validation
        //     if (!value || !value.type) {
        //         return true;
        //     }
        //     // Otherwise, check if the file type is allowed
        //     return ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        // })
        //     .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', value => {
        //         // If the value is falsy or not a file, skip the validation
        //         if (!value || !value.size) {
        //             return true;
        //         }
        //         // Otherwise, check if the file size is less than or equal to 1 MB
        //         const maxSize = 5000000; // 1 MB
        //         return value.size <= maxSize;
        //     }),

        fCourseTrainPath: Yup.mixed().test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
            // If the value is falsy or not a file, skip the validation
            if (!value || !value.type) {
                return true;
            }
            // Otherwise, check if the file type is allowed
            return ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
        })
            .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', value => {
                // If the value is falsy or not a file, skip the validation
                if (!value || !value.size) {
                    return true;
                }
                // Otherwise, check if the file size is less than or equal to 1 MB
                const maxSize = 5000000; // 5 MB
                return value.size <= maxSize;
            }),

        dataPersonTrainAr: Yup.array().min(1, "กรุณากรอกรายชื่อผู้เข้ารับการฝึกอบรม อย่างน้อย 1 รายการ")
    })

    const dataPersonInitialvalues = {
        id: 0,
        supportInnovationId: Number(searchParams.get("req")),
        fullName: "",
        personalNo: "",
        jobposition: "",
        remark: "",
        innovationCourses: courseInnovationId.map((course) => ({
            innovationCourseId: course.innovationCourseId,
            detailInnoCourses: course.listRegisters.map((classItem) => ({
                detailInnoCourseId: 0
            }))
        }))
    }

    const dataPersonValidateSchema = Yup.object().shape({
        fullName: Yup.string().required("กรุณากรอกชื่อ-นามสกุล"),
        personalNo: Yup.string().min(13, "เลขบัตรประจำตัวประชาชนต้องมีจำนวน 13 หลัก").required("กรุณากรอกเลขบัตรประจำตัวประชาชน"),
        jobposition: Yup.string().required("กรุณากรอกตำแหน่งงาน"),
        remark: Yup.string().nullable(),

    })

    const dataPersonOnsubmit = async (values, actions) => {
        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่?",
            text: "",
            confirmButtonColor: rootColorPrimary,
            confirmButtonText: "ยันยัน",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true)
                try {
                    let res = await fetch("/api/SupportInnovation/savePersonTrainInnovation", {
                        method: "POST",
                        headers: { "Content-type": "application/json" },
                        body: JSON.stringify(values)
                    });
                    let resJson = await res.json();
                    if (resJson.status === 1) {

                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "ต้องการบันทึกข้อมูลต่อหรือไม่ ?",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            getInnovationInitialValue();
                            // getTrainJobposition()
                            // ListTrainTestJobposition()
                            modalToggle()
                            if (result.isConfirmed) {
                                return;
                            } else {
                                navigate("/supporting/");
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (err) {
                    console.log("err =>", err)
                } finally {
                    setLoading(false);
                }
            }
        })

    }

    return (
        <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
            {loading ? (
                <Loading />
            ) : (
                <div className="w-100">
                    <Formik
                        initialValues={data ? data : initialValues}
                        validationSchema={validationFormSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {

                            const showErrorsFile = (name) => {

                                if (Object.keys(errors).length > 0) {
                                    let errorFields = [];
                                    let errorMessages = [];
                                    let errorText = "";
                                    for (let key in errors) {
                                        console.log("key", key)
                                        if (key === name) {
                                            const errorMessage = errors[key];
                                            if (!errorMessages.includes(errorMessage)) {
                                                errorMessages.push(errorMessage);
                                                errorFields.push(key);
                                                errorText += `<h6>${errorMessage}</h6>`;
                                            }
                                        }
                                    }
                                    if (errorFields.length > 0) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "แนบไฟล์ไม่สำเร็จ",
                                            html: errorText,
                                            confirmButtonColor: "#0A66C2",
                                            confirmButtonText: "ตกลง",
                                        }).then((result) => {
                                            errorFields.forEach((fieldName) => {
                                                setFieldValue(fieldName, "");
                                            });
                                        });
                                    }
                                }
                            }
                            const validateFile = (e) => {
                                const { name } = e.target;
                                setFieldValue(name, e.target.files[0]);
                                showErrorsFile(name)
                            }

                            // console.log("errors",errors)
                            console.log("values", values)
                            return (


                                <Form className="mb-4">
                                    <div className="d-flrx justify-content-center">
                                        <span className="input-color tex-center">{touched.dataPersonTrainAr && errors.dataPersonTrainAr ? <span className="text-danger">{errors.dataPersonTrainAr}</span> : null}</span>
                                        <div className="d-flex justify-content-end mb-3">
                                            <button
                                                type="button"
                                                className="btn-blue w-25"
                                                onClick={() => { modalFileToggle(!openModalFileForm) }}
                                            >
                                                แนบเอกสารเพิ่มเติม
                                            </button>
                                        </div>
                                        <Modal
                                            isOpen={openModalFileForm}
                                            toggle={modalFileToggle}
                                            // size="xl"
                                            style={{ maxWidth: "1140px", width: "100%" }}
                                            centered
                                            // className="modal-bordered "
                                            backdrop={"static"}
                                            keyboard={false}
                                        >
                                            <ModalHeader className="text-center" toggle={modalFileToggle}>แนบเอกสารเพิ่มเติม</ModalHeader>
                                            <ModalBody>
                                                <div className="mt-4">
                                                    {/* <FormGroup className="d-flex justify-content-between align-items-center">
                                                        <Label className="w-75">
                                                            หนังสือมอบอำนาจทำการแทนนิติบุคคล พร้อมติดอากรแสตมป์(กรณีมีการมอบอำนาจ)
                                                            {values.fAuthrisePathView ? (
                                                                <FaSistrix
                                                                    className="mx-3 style-icon"
                                                                    onClick={onClickUrl(`${values.fAuthrisePathView}`)}
                                                                />
                                                            ) : null}
                                                        </Label>
                                                        <div className="w-25">
                                                            <Input
                                                                name="fAuthrisePath"
                                                                type="file"
                                                                onBlur={handleBlur}
                                                                className={
                                                                    touched.fAuthrisePath && errors.fAuthrisePath
                                                                        ? "input-error rounded-pill text-center input-color"
                                                                        : "rounded-pill text-center input-color"
                                                                }
                                                                onChange={(e) => {
                                                                    // handleChange(e)
                                                                    if (e.target && e.target.files[0]) {
                                                                        setFieldValue(`fAuthrisePath`, e.target.files[0]);
                                                                    }
                                                                }}
                                                            />

                                                        </div>
                                                    </FormGroup>

                                                    <FormGroup className="d-flex justify-content-between align-items-center">
                                                        <Label className="w-75">
                                                            สำเนาบัตรประจำตัวประชาชนของผู้มอบอำนาจ (กรณีมีการมอบอำนาจ)
                                                            {values.fIdCardPathView ? (
                                                                <FaSistrix
                                                                    className="mx-3 style-icon"
                                                                    onClick={onClickUrl(`${values.fIdCardPathView}`)}
                                                                />
                                                            ) : null}
                                                        </Label>
                                                        <div className="w-25">
                                                            <Input
                                                                name="fIdCardPath"
                                                                type="file"
                                                                onBlur={handleBlur}
                                                                className={
                                                                    touched.fIdCardPath && errors.fIdCardPath
                                                                        ? "input-error rounded-pill text-center input-color"
                                                                        : "rounded-pill text-center input-color"
                                                                }
                                                                onChange={(e) => {
                                                                    // handleChange(e)
                                                                    if (e.target && e.target.files[0]) {
                                                                        setFieldValue(`fIdCardPath`, e.target.files[0]);
                                                                    }
                                                                }}
                                                            />

                                                        </div>
                                                    </FormGroup> */}

                                                    <FormGroup className="d-flex justify-content-between align-items-center">
                                                        <Label className="w-75">
                                                            หลักสูตรการฝึกอบรม (กรณีฝึกอบรมหลักสูตรเพื่อนำเทคโนโลยีมาใช้ในการผลิตสินค้าหรือบริการ)
                                                            {values.fCourseTrainPathView ? (
                                                                <FaSistrix
                                                                    className="mx-3 style-icon"
                                                                    onClick={onClickUrl(`${values.fCourseTrainPathView}`)}
                                                                />
                                                            ) : null}
                                                        </Label>
                                                        <div className="w-25">
                                                            <Input
                                                                name="fCourseTrainPath"
                                                                type="file"
                                                                onBlur={handleBlur}
                                                                className={
                                                                    touched.fCourseTrainPath && errors.fCourseTrainPath
                                                                        ? "input-error rounded-pill text-center input-color"
                                                                        : "rounded-pill text-center input-color"
                                                                }
                                                                onChange={(e) => {
                                                                    // handleChange(e)
                                                                    if (e.target && e.target.files[0]) {
                                                                        setFieldValue(`fCourseTrainPath`, e.target.files[0]);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </FormGroup>

                                                    <FormGroup className="d-flex justify-content-between align-items-center">
                                                        <Label className="w-75">
                                                            เอกสารอื่นๆ (ถ้ามี)
                                                            {values.fOtherPathView ? (
                                                                <FaSistrix
                                                                    className="mx-3 style-icon"
                                                                    onClick={onClickUrl(`${values.fOtherPathView}`)}
                                                                />
                                                            ) : null}
                                                        </Label>
                                                        <div className="w-25">
                                                            <Input
                                                                name="fOtherPath"
                                                                type="file"
                                                                onBlur={handleBlur}
                                                                className={
                                                                    touched.fOtherPath && errors.fOtherPath
                                                                        ? "input-error rounded-pill text-center input-color"
                                                                        : "rounded-pill text-center input-color"
                                                                }
                                                                onChange={(e) => {
                                                                    if (e.target && e.target.files[0]) {
                                                                        setFieldValue(`fOtherPath`, e.target.files[0]);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </FormGroup>
                                                </div>

                                                <ModalFooter className="d-flex justify-content-center">
                                                    <button
                                                        className="btn-blue w-25"
                                                        type="button"
                                                        onClick={() => { modalFileToggle(!openModalFileForm) }}>
                                                        ตกลง
                                                    </button>
                                                </ModalFooter>

                                            </ModalBody>



                                        </Modal>


                                        <Formik
                                            initialValues={isEditing ? selectItem : dataPersonInitialvalues}
                                            validationSchema={dataPersonValidateSchema}
                                            onSubmit={dataPersonOnsubmit}
                                            enableReinitialize
                                        >
                                            {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange, resetForm }) => {




                                                const onAddTestDetail = () => {
                                                    setIsEditing(false)
                                                    setSelectItem(null)
                                                    resetForm()
                                                    modalToggle();
                                                };

                                                const AddDetailTestBtn = () => {
                                                    return (
                                                        <button
                                                            className="btn border border-1 text-white btn-green"
                                                            // style={{backgroundColor:"#0A66C2"}}
                                                            onClick={() => onAddTestDetail()}
                                                        >
                                                            <BsPlusLg className="mx-2" />
                                                            เพิ่ม
                                                        </button>
                                                    );
                                                };

                                                const dataPersonOnEdit = async (row) => {
                                                    resetForm();
                                                    setFieldValue("id", row.id)
                                                    setFieldValue("fullName", row.fullName)
                                                    setFieldValue("jobposition", row.jobposition)
                                                    setFieldValue("personalNo", row.personalNo)
                                                    setFieldValue("remark", row.remark)
                                                    console.log("row", row)
                                                    await courseInnovationId.forEach((course, i) => {
                                                        row.innovationCourses.forEach((mycourse) => {
                                                            if (course.innovationCourseId === mycourse.innovationCourseId) {
                                                                course.listRegisters.forEach((classItem, index) => {
                                                                    mycourse.detailInnoCourses.forEach((myClass) => {
                                                                        if (classItem.detailInnoCourseId === myClass.detailInnoCourseId) {
                                                                            setFieldValue(`innovationCourses[${i}].detailInnoCourses[${index}].detailInnoCourseId`, classItem.detailInnoCourseId);
                                                                        }
                                                                    })
                                                                })
                                                            }
                                                        })
                                                    })
                                                    await modalToggle(!openModalForm)
                                                }
                                                async function OnDelete(id) {
                                                    Swal.fire({
                                                        icon: "info",
                                                        title: "ยืนยันการลบข้อมูลหรือไม่?",
                                                        text: "",
                                                        confirmButtonColor: rootColorPrimary,
                                                        confirmButtonText: "ยันยัน",
                                                        cancelButtonText: 'ยกเลิก',
                                                        cancelButtonColor: '#d33',
                                                        showCancelButton: true,
                                                    }).then(async (result) => {
                                                        if (result.isConfirmed) {
                                                            let postData = new FormData();
                                                            postData.append("id", id)
                                                            try {
                                                                let res = await fetch("/api/SupportInnovation/deletePersonTrainInnovation", {
                                                                    method: "POST",
                                                                    body: postData
                                                                });
                                                                let resJson = await res.json();

                                                                if (resJson.status === 1) {
                                                                    getInnovationInitialValue()
                                                                    // getTrainJobposition()
                                                                    // ListTrainTestJobposition()
                                                                    Swal.fire({
                                                                        icon: "success",
                                                                        title: "ลบข้อมูลสำเร็จ",
                                                                        text: "",
                                                                        confirmButtonColor: "#0A66C2",
                                                                        confirmButtonText: "ตกลง",
                                                                    }).then(() => {
                                                                        window.location.reload();

                                                                    });
                                                                } else {
                                                                    Swal.fire({
                                                                        icon: "error",
                                                                        title: "ลบข้อมูลไม่สำเร็จ",
                                                                        text: `เนื่องจาก ${resJson.message}`,
                                                                        confirmButtonColor: "#0A66C2",
                                                                        confirmButtonText: "ตกลง",
                                                                    });
                                                                }

                                                            } catch (e) {
                                                                console.log("err", e)
                                                            }
                                                        }
                                                    })
                                                }

                                                const COLUMNS = [
                                                    {
                                                        Header: "ลำดับ",
                                                        accessor: (_row, i) => i + 1,
                                                    },
                                                    {
                                                        Header: "ชื่อ-สกุล",
                                                        accessor: "fullName",
                                                    },
                                                    {
                                                        Header: "เลขบัตรประจำตัวประชาชน",
                                                        accessor: "personalNo",
                                                    },
                                                    {
                                                        Header: "ตำแหน่งงาน",
                                                        accessor: "jobposition",
                                                    },
                                                    {
                                                        Header: "รายละเอียด",
                                                        accessor: "id",
                                                        Cell: ({ row, value }) => {
                                                            return (
                                                                <div className="text-center">
                                                                    <button
                                                                        type="button"
                                                                        className="btn border border-1 mx-1"
                                                                        onClick={() =>
                                                                            dataPersonOnEdit(row.original)
                                                                        }
                                                                    >
                                                                        <FiEdit3 style={{ color: rootColorPrimary }} />
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn border border-1 mx-1"
                                                                        onClick={() =>
                                                                            OnDelete(row.original.id)
                                                                        }
                                                                    >
                                                                        <AiOutlineDelete style={{ color: rootColorErrors }} />
                                                                    </button>
                                                                </div>
                                                            );
                                                        },
                                                    },
                                                ];

                                                return (
                                                    <div>
                                                        <CreateTableComponent
                                                            column={COLUMNS}
                                                            dataInput={dataPerson}
                                                            FormInput={AddDetailTestBtn}
                                                            showEntrie={true}
                                                            showPage={false}
                                                        />

                                                        <Modal
                                                            isOpen={openModalForm}
                                                            toggle={modalToggle}
                                                            size="lg"
                                                            centered
                                                            backdrop={"static"}
                                                            keyboard={false}
                                                        >
                                                            <ModalHeader className="text-center" toggle={modalToggle}>
                                                                กรุณากรอกข้อมูลผู้เข้ารับการฝึกอบรม
                                                            </ModalHeader>
                                                            <ModalBody>
                                                                <div>
                                                                    <Form autoComplete="off" className="">
                                                                        <div className="p-4">
                                                                            <FormGroup>
                                                                                <Field name="id" disabled={true} className="d-none" />
                                                                                <div>
                                                                                    <Label>กรุณาเลือกหลักสูตร</Label>
                                                                                    {touched.courseForSelect && errors.courseForSelect ? (
                                                                                        <span className="text-left text-danger px-1">
                                                                                            {errors.courseForSelect}
                                                                                        </span>
                                                                                    ) : null}

                                                                                    <FieldArray name={`innovationCourses`}>
                                                                                        {(fieldArrayProps) => {
                                                                                            return (
                                                                                                <>
                                                                                                    {courseInnovationId?.map((course, i) => (
                                                                                                        <div className='mt-3 px-3' key={i}>
                                                                                                            <li>หลักสูตร <span style={{ color: "#0A66C2" }}>{course.innovationCourseName}</span></li>
                                                                                                            {course.listRegisters.map((classItem, index) => (
                                                                                                                <div key={index}>
                                                                                                                    <div className="d-flex align-items-center mt-3">
                                                                                                                        <Field
                                                                                                                            name={`innovationCourses[${i}].detailInnoCourses[${index}].detailInnoCourseId`}
                                                                                                                            type="checkbox"
                                                                                                                        >
                                                                                                                            {({ field, meta, form }) => (
                                                                                                                                <Input
                                                                                                                                    type="checkbox"
                                                                                                                                    className="ms-2 cus-type m-0"
                                                                                                                                    {...field}
                                                                                                                                    onChange={(e) => {
                                                                                                                                        handleChange(e)
                                                                                                                                        if (e.target.checked) {
                                                                                                                                            setFieldValue(`innovationCourses[${i}].detailInnoCourses[${index}].detailInnoCourseId`, classItem.detailInnoCourseId);
                                                                                                                                        } else {
                                                                                                                                            setFieldValue(`innovationCourses[${i}].detailInnoCourses[${index}].detailInnoCourseId`, 0);
                                                                                                                                            // setFieldValue(`innovationCourses[${i}].detailInnoCourses[${index}].personAmount`, "");
                                                                                                                                        }
                                                                                                                                    }}
                                                                                                                                    checked={values.innovationCourses[i].detailInnoCourses[index].detailInnoCourseId !== 0 ? true : false}
                                                                                                                                />
                                                                                                                            )}

                                                                                                                        </Field>
                                                                                                                        <span className='ms-2'>
                                                                                                                            รุ่นที่ <span style={{ color: "#0A66C2" }}>{classItem.classItem}</span>
                                                                                                                        </span>
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </>
                                                                                            )
                                                                                        }}


                                                                                    </FieldArray>



                                                                                    <Label className="mt-3 mx-1">ชื่อ-นามสกุล</Label>
                                                                                    {touched.fullName && errors.fullName ? (
                                                                                        <span className="text-left text-danger px-1">
                                                                                            {errors.fullName}
                                                                                        </span>
                                                                                    ) : null}
                                                                                    <Field name="fullName">
                                                                                        {({ field, meta }) => (
                                                                                            <Input
                                                                                                type="text"
                                                                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                                {...field}
                                                                                            />
                                                                                        )}
                                                                                    </Field>

                                                                                    <Label className="mt-3">เลขบัตรประจำตัวประชาชน</Label>
                                                                                    {errors.personalNo && touched.personalNo ? (
                                                                                        <span className="text-left text-danger px-1">
                                                                                            {errors.personalNo}
                                                                                        </span>
                                                                                    ) : null}
                                                                                    <Field name="personalNo">
                                                                                        {({ field, meta, form: { setFieldValue, values } }) => (
                                                                                            <Input
                                                                                                type="text"
                                                                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                                {...field}
                                                                                                maxLength={13}
                                                                                                min={13}

                                                                                            />
                                                                                        )}
                                                                                    </Field>
                                                                                    <Label className="mt-3">ตำแหน่งงาน</Label>
                                                                                    {touched.jobposition && errors.jobposition ? (
                                                                                        <span className="text-left text-danger px-1">
                                                                                            {errors.jobposition}
                                                                                        </span>
                                                                                    ) : null}

                                                                                    <Field name="jobposition">
                                                                                        {({ field, meta }) => (
                                                                                            <Input
                                                                                                type="text"
                                                                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color mx-1" : "rounded-pill text-center input-color mx-1"}
                                                                                                {...field}
                                                                                            />
                                                                                        )}
                                                                                    </Field>




                                                                                    <Label className="mt-3">หมายเหตุ</Label>
                                                                                    {touched.remark && errors.remark ? (
                                                                                        <span className="text-left text-danger px-1">
                                                                                            {errors.remark}
                                                                                        </span>
                                                                                    ) : null}
                                                                                    <Field name="remark">
                                                                                        {({ field, meta }) => (
                                                                                            <Input
                                                                                                type="text"
                                                                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                                                                {...field}
                                                                                            />
                                                                                        )}
                                                                                    </Field>


                                                                                </div>

                                                                            </FormGroup>
                                                                        </div>


                                                                        <ModalFooter className="d-flex justify-content-center">
                                                                            <button
                                                                                className="btn-blue w-50"
                                                                                type="submit"

                                                                            >
                                                                                บันทึก
                                                                            </button>
                                                                        </ModalFooter>
                                                                    </Form>
                                                                </div>
                                                            </ModalBody>
                                                        </Modal>
                                                    </div>
                                                )
                                            }}


                                        </Formik>



                                    </div>

                                    <div className="mt-3 d-flex justify-content-between mt-4">
                                        <button onClick={checkPreviousPage} type="button" className="btn-blue w-25">ย้อนกลับ</button>
                                        <button className="btn-blue w-25" type="submit">ถัดไป</button>
                                    </div>

                                </Form>
                            )
                        }}
                    </Formik>

                </div>
            )}


        </Container>

    )
}